<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
import WorkOrderItems from '@/components/widgets/work-order-items/by-item-grid';
import ItemSuppliers from '@/components/widgets/item-suppliers';
import SharedUrlButton from '@/components/widgets/buttons/shared-url';
import ItemQuantitiesInfo from '../shared/item-quantities-info.vue';

import ModifyItemModal from '../shared/modals/modify-item.vue';

export default {
  props: {
    itemIdPublic: String,
  },
  components: {
    Loading,
    WorkOrderItems,
    ItemSuppliers,
    ItemQuantitiesInfo,
    ModifyItemModal,
    SharedUrlButton,
  },
  data() {
    return {
      isLoading: false,
      item: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.item = null;
      this.isLoading = true;
      ItemsRepository.get(this.itemIdPublic)
        .then((response) => {
          this.item = response.data;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        })
        .finally(() => (this.isLoading = false));
    },
    removedWorkOrderItem(woItem) {
      this.item.reservedQuantity -= woItem.reservedQuantity;

      if (this.item.reservedQuantity < 0) {
        this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
        this.loadData();
      }
    },
    modifyQuantityModal() {
      this.$bvModal.show('modify-items-modal');
    },
    sharedUrlKeyUpdated(key) {
      this.item.sharedUrlKey = key;
    },
    itemUpdated(item) {
      this.item = item;
    },
  },
  computed: {
    sharedUrl() {
      if (this.item == null || this.item.id == null || this.item.id <= 0) {
        return null;
      }

      return (
        process.env.VUE_APP_REDIRECT_URL +
        'shared/' +
        this.$store.state.user.config.organisationCode +
        '/consumption/items/' +
        this.item.id
      );
    },
    sharedUrlRepo() {
      return ItemsRepository;
    },
  },
};
</script>

<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div v-if="item != null">
      <header class="flex-box">
        <h1>
          {{ item.name }}
        </h1>

        <div
          @click="modifyQuantityModal"
          class="flex-push"
          style="cursor: pointer; font-size: 2.5em; white-space: nowrap"
        >
          <i class="fas fa-minus text-danger pl-2 pt-1 pb-1"></i>
          <span
            class="text-secondary pl-1 pr-1"
            style="font-weight: 800; font-size: 0.9em"
          >
            /
          </span>
          <i class="fas fa-plus text-success pr-2 pt-1 pb-1"></i>
        </div>
      </header>

      <b-container fluid>
        <b-row class="mt-2">
          <b-col xl="8" lg="12">
            <ItemQuantitiesInfo
              :item="item"
              @item-updated="itemUpdated"
              @reload-item="loadData"
            />
          </b-col>
          <b-col xl="4" lg="12" class="text-right align-bottom mt-auto">
            <SharedUrlButton
              v-if="sharedUrl != null"
              :repository="sharedUrlRepo"
              :objectId="item.id"
              target="itemSharedLink"
              :baseSharedUrl="sharedUrl"
              :baseSharedKey="item.sharedUrlKey"
              @shared-url-key-updated="sharedUrlKeyUpdated"
              :title="item.categoryName"
              :description="item.name"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col xl="5" lg="12">
            <WorkOrderItems
              :itemIdPublic="item.idPublic"
              @removed-woitem="removedWorkOrderItem"
            />
          </b-col>
          <b-col xl="7" lg="12">
            <ItemSuppliers :itemIdPublic="item.idPublic" />
          </b-col>
        </b-row>
      </b-container>

      <ModifyItemModal
        v-if="item != null"
        :item="item"
        @item-updated="itemUpdated"
      />
    </div>
  </div>
</template>